import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "trophy-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.30888 13.25C6.66851 15.5169 8.63199 17.25 11 17.25H11.25V19.75H9C8.58579 19.75 8.25 20.0858 8.25 20.5C8.25 20.9142 8.58579 21.25 9 21.25H15C15.4142 21.25 15.75 20.9142 15.75 20.5C15.75 20.0858 15.4142 19.75 15 19.75H12.75V17.25H13C15.368 17.25 17.3315 15.5169 17.6911 13.25H18C20.0712 13.25 21.75 11.5712 21.75 9.5V7.5C21.75 6.53379 20.9662 5.75 20 5.75H17.75V4.5C17.75 3.53379 16.9662 2.75 16 2.75H8C7.03379 2.75 6.25 3.53379 6.25 4.5V5.75H4C3.03379 5.75 2.25 6.53379 2.25 7.5V9.5C2.25 11.5712 3.92879 13.25 6 13.25H6.30888ZM8 4.25C7.86221 4.25 7.75 4.36221 7.75 4.5V12.5C7.75 14.2948 9.20521 15.75 11 15.75H13C14.7948 15.75 16.25 14.2948 16.25 12.5V4.5C16.25 4.36221 16.1378 4.25 16 4.25H8ZM6.25 11.75V7.25H4C3.86221 7.25 3.75 7.36221 3.75 7.5V9.5C3.75 10.7428 4.75721 11.75 6 11.75H6.25ZM20 7.25H17.75V11.75H18C19.2428 11.75 20.25 10.7428 20.25 9.5V7.5C20.25 7.36221 20.1378 7.25 20 7.25Z"
    }, null, -1)
  ])))
}
export default { render: render }